import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { empty } from 'rxjs';
import { Globals } from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'client';
  url: any = '';
  public sound: string;
  theGlobal:any;

  constructor(location: Location, router: Router, globals: Globals){
    this.url = location.path();
    this.theGlobal = globals;
    this.sound = globals.sound;
    // router.events.subscribe(val => {
    //   console.log('val > ', val);
    // });
    // localStorage['firstLoad'] = false;
  }
  ngOnInit(): void {
    // console.log('this.sound > ',this.sound);
  }

  toggleSound(){
    this.sound = this.theGlobal.toggleSound();
  }

  clickContact(){
    this.theGlobal.goToContact();
  }

  changeSoundAletoryByRange(){

  }
}
